import Marquee from "react-fast-marquee";

export function BrandMarquee({ speed = 40, dark = false }) {
  const items = ["MARKIE 2 FRESH", "NEW YORK CITY", "NIGHTLIFE", "GOOD PEOPLE", "LOUD MUSIC"];
  return (
    <div className={`border-y ${dark ? "border-white/15 bg-brand-ink" : "border-brand-ink/15 bg-brand-cream"} py-6 overflow-hidden`}>
      <Marquee speed={speed} gradient={false} autoFill>
        {items.map((t, i) => (
          <span key={i} className="flex items-center">
            <span
              className={`font-head font-extrabold uppercase text-5xl md:text-7xl tracking-tight px-8 text-brand-orange`}
            >
              {t}
            </span>
            <span className="text-brand-ink text-4xl md:text-6xl">✦</span>
          </span>
        ))}
      </Marquee>
    </div>
  );
}
